import { DialogService } from 'app/services/dialog.service';
import { ChangeDetectorRef, Component, ComponentRef, inject, Injector, ViewChild, ViewContainerRef } from '@angular/core';
import { ReportTemplateService } from '../../../../services/reporttemplate.service';
import { ContainersService } from '../../../../services/containers.service';
import { DialogBaseComponent } from "../../base-admin-panel/dialog-base/dialog-base.component";
import { ReportTemplateViewModel } from '../Models/ReportTemplateViewModel';
import { ReportColumnModel } from '../Models/ReportColumnModel';
import { ReportTemplateColumnViewModel } from '../Models/ReportTemplateColumnViewModel';
import { ObjectsManagementDialogComponent } from '../../objects-management-dialog/objects-management-dialog.component';
import { ContainerViewModel } from '../../ContainerViewModel';
import { ContainerAcl } from 'app/models/ContainerAcl';

@Component({
  selector: 'app-report-dialog-base',
  templateUrl: './report-dialog-base.component.html',
  styleUrls: ['./report-dialog-base.component.css'],
  standalone: false
})
export class ReportDialogBaseComponent extends DialogBaseComponent<ReportTemplateViewModel> {
  public columns: ReportColumnModel[] = [];
  public resColumns: ReportColumnModel[] = [];
  public reportTypes = new Map<number, string>();
  public containers: ContainerViewModel[] = [];
  public creatableContainers: ContainerViewModel[] = [];
  protected reportService: ReportTemplateService;
  protected containersService: ContainersService;
  @ViewChild("columnsListDialog", { read: ViewContainerRef, static: true }) objectsListContainer;
  private columnsListDialog: ComponentRef<any>;
  public dialogService = inject(DialogService);
  currentUser: import("../../../../services/users.service").UserViewModel;

  constructor(protected injector: Injector) {
    super(injector);
    this.reportService = injector.get(ReportTemplateService);
    this.containersService = injector.get(ContainersService);
  }
  ngOnInit() {
    this.currentUser = this.usersService.getCurrentUser();

    this.reportService.getReportTypes()
      .subscribe(types => {
        this.reportTypes = types;
      });

    this.loadContainers();
    this.onReportChange();
  }


  public get reportType(): string {
    return this.model.Type.toString();
  }

  public set reportType(value: string) {
    this.model.Type = parseInt(value);
  }

  public get isEditMode(): boolean {
    return (this.model?.Id ?? 0) > 0;
  }

  public getSelectedContainerName(): string {
    const containerId = this.model?.ContainerId;
    if (!containerId) return "";
    return this.containers.find(x => x.Id === containerId)?.Name ?? "";
  }


  private PrepareColumns(types: ReportColumnModel[]) {
    // reorder and set checkboxes
    types.forEach(el => {
      if (!el.Name) {
        el.Name = this.translate.instant(el.Description);
      }

      el.IsChecked = false;
    });
  }

  public onReportChange() {
    this.reportService.getReportColumnTypes(this.model.Type)
      .subscribe(types => {
        const result: ReportColumnModel[] = [];

        // Important: clear old selected columns
        this.resColumns = [];

        this.PrepareColumns(types);

        for (let i = 0; i < this.model.Columns.length; i++) {
          const column = this.model.Columns[i];

          const idx = types.findIndex(x => x.Type == column.Type);

          if (idx >= 0) {
            types[idx].Value = column.Value;
            types[idx].Name = column.Name === ""
              ? this.translate.instant(types[idx].Description)
              : column.Name;

            types[idx].IsChecked = true;

            const newObject = Object.assign({}, types[idx]);
            this.resColumns.push(newObject);

            // Important: remove it from types so it is not added twice
            types.splice(idx, 1);
          }
        }

        result.push(...this.resColumns);
        result.push(...types);

        this.columns = result;
        this.model.Type = Number(this.model.Type);
      });
  }
  override open(model: ReportTemplateViewModel, type: { new(): ReportTemplateViewModel } = undefined) {
    super.open(model, type);
    this.loadContainers();
  }

  public validate(): boolean {
    this.model.Columns = [];

    for (let i = 0; i < this.resColumns.length; i++) {
      var col = new ReportTemplateColumnViewModel();
      col.Type = this.resColumns[i].Type;
      col.Value = this.resColumns[i].Value;
      col.Name = this.resColumns[i].Name;
      this.model.Columns.push(col);
    }

    if (this.model.Name == "" || this.model.Name == undefined) {
      this.toastr.error(this.translate.instant('The name field is required'));
      return false;
    }
    if (this.model.Columns.length <= 0) {
      this.toastr.error(this.translate.instant('Choose columns'));
      return false;
    }
    return true;
  }

  public pullUp(el: ReportColumnModel) {
    var idx = this.resColumns.findIndex(x => x === el);
    if (idx > 0) {
      this.resColumns.splice(idx, 1);
      this.resColumns.splice(idx - 1, 0, el);
    }
  }

  public pullDown(el: ReportColumnModel) {
    var idx = this.resColumns.findIndex(x => x === el);
    if (idx < this.resColumns.length - 1) {
      this.resColumns.splice(idx, 1);
      this.resColumns.splice(idx + 1, 0, el);
    }
  }


  public openAddColumnDialog() {
    this.columnsListDialog = this.dialogService.open(this.objectsListContainer, ObjectsManagementDialogComponent);
    this.columnsListDialog.instance.isSingleItem = false;
    this.columns.forEach(x => x.IsChecked = false);
    this.columnsListDialog.instance.onOpen.subscribe(() => {
      this.reportService.getReportColumnTypes(this.model.Type)
        .subscribe(types => {
          this.PrepareColumns(types);
          this.columnsListDialog.instance.objects = types;
        });
    });
    this.columnsListDialog.instance.onSubmit.subscribe(() => {
      this.columnsListDialog.instance.objects.forEach(column => {
        if (column && column.IsChecked) {
          const clone = structuredClone(column);
          clone.IsChecked = false;
          this.resColumns.push(clone);
        }
        column.IsChecked = false;
      });
      this.columnsListDialog.instance.close();
    });
    this.columnsListDialog.instance.onClose.subscribe(() => {
    });
    this.columnsListDialog.instance.open();
  }

  public deleteColumn(column: ReportColumnModel) {
    const index = this.resColumns.indexOf(column);
    if (index > -1) {
      this.resColumns.splice(index, 1);
    }
  }

  private ensureContainerSelected() {
    if (!this.model) return;

    const availableContainers = this.isEditMode ? this.containers : this.creatableContainers;
    if (availableContainers.length === 0) {
      if (!this.isEditMode)
        this.model.ContainerId = undefined;
      return;
    }

    if (this.model.ContainerId && availableContainers.some(x => x.Id === this.model.ContainerId))
      return;

    this.model.ContainerId = availableContainers[0]?.Id;
  }

  private loadContainers() {
    const companyId = this.model?.CompanyId || this.usersService.getCurrentUser()?.CompanyId;
    if (!companyId) {
      this.containers = [];
      this.creatableContainers = [];
      if (this.model && !this.isEditMode)
        this.model.ContainerId = undefined;
      return;
    }

    this.containersService.GetContainers().subscribe(containers => {
      this.containers = [...(containers ?? [])]
        .sort((a, b) => (a.Name ?? "").localeCompare(b.Name ?? ""));
      this.creatableContainers = this.getCreatableContainers(this.containers);
      this.ensureContainerSelected();
    });
  }

  private getCreatableContainers(containers: ContainerViewModel[]): ContainerViewModel[] {
    return containers.filter(container =>
      (this.getContainerAcl(container) & ContainerAcl.CreateReportTemplate) === ContainerAcl.CreateReportTemplate);
  }

  private getContainerAcl(container: ContainerViewModel): number {
    if (!this.currentUser)
      return 0;

    if (this.currentUser.CanDo(this.AccessRights.EDITUSERS) || this.currentUser.CanDo(this.AccessRights.EDIT_ALL_USERS))
      return ContainerAcl.CreateReportTemplate | ContainerAcl.EditReportTemplate | ContainerAcl.DeleteReportTemplate;

    const userId = this.currentUser.Id;
    const aclFromUsers = container.Users?.find(link => link.UserId === userId)?.ACL;
    const fallbackAcl = (this.currentUser.ContainerLinks ?? []).find(link => link.ContainerId === container.Id)?.ACL;
    return aclFromUsers ?? fallbackAcl ?? 0;
  }
}
